import Parameters from 'shared/parameters';

const BASE_URL = Parameters.ApiUrl;
export default {
    // The BASE url to access the API
    BASE_URL: BASE_URL + '/' // + Locale.getLocale() + '/'
}
